import { Button, Grid, LinearProgress, Paper } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import React, { useContext, useEffect } from "react";
import useApi from "../../../../../hooks/api";
import { CrmContext } from "../../context";
import {
  TradeBasicData,
  TradeComments,
  TradeData,
  TradeTaskNew,
  TradeTasksList,
} from "./sections";

export default function CrmTradeDetails() {
  const context = useContext(CrmContext);

  const { get } = useApi();

  useEffect(() => {
    get(`/v1/crm/trades/${context.tradeId}`)
      .then((response) => {
        context.setTrade(response.data);
      })
      .catch((err) => {
        context.setError(err);
      });
  }, []);

  return context.loading ? (
    <LinearProgress />
  ) : (
    <Grid container spacing={2} style={{ height: "80vh" }}>
      <Grid item xs={12} md={4}>
        <Grid container direction="column" spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Paper elevation={4}>
                  <Button
                    fullWidth
                    style={{ height: "36px" }}
                    startIcon={<ArrowBackIosIcon />}
                    onClick={context.unsetTrade}
                  >
                    Voltar
                  </Button>
                </Paper>
              </Grid>

              <Grid item xs={6}>
                <Paper style={{ height: "36px" }}>
                  <div className="crm-trade-started-at">
                    <p className="m-text-center m-0">
                      <span className="m-bold-600">{`Início:${" "}`}</span>
                      {context.trade.created_at}
                    </p>
                  </div>
                </Paper>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Paper elevation={4}>
              <TradeBasicData trade={context.trade} />
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper elevation={4}>
              <TradeComments />
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} md={8}>
        <Paper elevation={4}>
          <TradeData context={context} />
        </Paper>

        <Grid item style={{ padding: "16px 0px 0px" }}>
          <Grid container direction="row" spacing={2}>
            <Grid item lg={7} sm={12}>
              <Paper elevation={4}>
                <TradeTaskNew />
              </Paper>
            </Grid>

            <Grid item lg={5} sm={12}>
              <Paper elevation={4}>
                <TradeTasksList />
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
